var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var PushService = /** @class */ (function () {
    function PushService(api) {
        this.API = api;
    }
    PushService.prototype.getPushNotifications = function (appId) {
        var url = "/push/".concat(appId, "/messages");
        return this.API.get(url);
    };
    PushService.prototype.removePushNotification = function (pushId) {
        var url = "/push/".concat(pushId);
        return this.API.delete(url);
    };
    PushService.prototype.archivePushNotification = function (appId, pushId, archive) {
        var url = "/push/".concat(appId, "/").concat(pushId);
        return this.API.patch(url, { archive: archive });
    };
    PushService.prototype.bulkArchive = function (appId, pushIds, archive) {
        var url = "/push/".concat(appId, "/archives");
        return this.API.patch(url, { archive: archive, ids: pushIds }, false, { appId: appId });
    };
    PushService.prototype.readPushCertificate = function (appId) {
        var url = "/push/".concat(appId, "/cert/web");
        return this.API.get(url);
    };
    PushService.prototype.createPushCertificate = function (appId) {
        var url = "/push/".concat(appId, "/cert/web");
        return this.API.post(url);
    };
    PushService.prototype.sendPushNotification = function (_a) {
        var appId = _a.appId, value = _a.value, sendAt = _a.sendAt, platform = _a.platform, title = _a.title, message = _a.message, selectedPushTemplateId = _a.selectedPushTemplateId, selectedPatchId = _a.selectedPatchId, selectedDatasetId = _a.selectedDatasetId, selectedRowId = _a.selectedRowId, pushTemplateMappedArray = _a.pushTemplateMappedArray, attachments = _a.attachments, test = _a.test;
        var dataset_data = Boolean(selectedDatasetId)
            ? {
                dataset: selectedDatasetId,
                item_id: selectedRowId,
            }
            : {};
        var template_meta = Boolean(selectedPatchId)
            ? {
                template: selectedPushTemplateId,
                view_patch: selectedPatchId,
                dataset: selectedDatasetId,
                meta: pushTemplateMappedArray,
            }
            : {};
        var pushObject = {
            app: appId,
            scope: value,
            send_at: sendAt,
            platform: platform,
            push_message: {
                title: title,
                body: message,
                meta: __assign({ patch_id: selectedPatchId, dataset_data: dataset_data, attachments: attachments }, (Boolean(selectedPatchId) ? { template_meta: template_meta } : {})),
            },
            test: test,
        };
        var url = "/push/".concat(appId, "/messages");
        return this.API.post(url, pushObject);
    };
    return PushService;
}());
export { PushService };
